import { getInstance } from "../../core/axios-gateway";
import { TPaymentMethodV2 } from "../../types/payment-method-v2";

export const getPaymentMethods = async () => {
  return getInstance()
    .get<TPaymentMethodV2[]>("/api/payment-methods")
    .then((res) => res.data);
};
